<template>
   <div id="m-header">
        <div class="right">
          <img class="right-img" src="../../assets/mdashu/navlogo.png" alt="">
          <i class="el-icon-s-operation right-i" @click.stop="didClickMenus"></i>
          <ul :class="{active: isShow, none: !isShow}">
            <li class="item-top" @click="closeul" ><i class="el-icon-close closei"></i></li>
            <li v-for="(item, index) in menus"
                :key="index" @click="didSelectItem(index , item.path)"
                :class="item.class" :style="navName == item.path ? 'color:#000000' : ''">
                {{item.name}}
            </li>
          </ul>
        </div>
    </div>
</template>  

<script>
export default {
  name: 'm-header',
  mounted() {
    let screenWidth = window.screen.width
    let baseWidth = 1920
    this.iSize = screenWidth / baseWidth * 200 + 'px'
  },
  data() {
    return {
      isShow: false,
      navName: 'Index',
      menus: [
        {
          name: '首页',
          class: 'item-normal item-first',
          path:'Index'
        },
        {
          name: '我们的服务',
          class: 'item-normal',
          path:'mEnter'
        },
        {
          name: '创新',
          class: 'item-normal',
          path:'mChildren'
        },
        {
          name: '新闻中心',
          class: 'item-normal',
          path:'mNotice'
        },
        {
          name: '关于我们',
          class: 'item-normal',
          path:'mSchool'
        },
        {
          name: '加入我们',
          class: 'item-last',
          path:'mRecruit'
        }
      ],
      iSize: 50
    }
  },
  methods: {
    didClickMenus() {
      this.isShow = true
    },
    didSelectItem(index ,name ) {
      this.$emit('select-menu', index)
      this.navName = name
      this.$router.push({ name: name })
    },
    closeul() {
      if (this.isShow) {
        this.isShow = false
      }
    } 
  }
}
</script>


<style scoped>
#m-header {
  background-color: white;
  display: flex;
  /* padding: 1.08rem 1.6rem; */
}
.right {
  flex: 1;
  height: 0.96rem;
  text-align: right;
  position: relative;
  background: white;
  border-top: 0.08rem solid #76c3a2;
}
.right-img {
  position: absolute;
  left: 0;
  top: 0;
  height: 0.62rem;
  margin: 0.18rem 0 0.18rem 0.6rem;
}
.right-i {
  position: absolute;
  right: 0;
  top: 0;
  font-size: 0.62rem;
  margin: 0.18rem 0.6rem 0.18rem 0;
  color: #76c3a2;
}
.none {
  display: none;
}
.active {
  position: absolute;
  width: 5rem;
  background-color: rgb(161, 206, 243);
  /* background-color: rgb(255, 255, 255); */
  right: 0;
  top: 0;
  padding: 0 0.4rem 0.4rem;
}
.item-top {
  font-size: 0.62rem;
  list-style-type: none;
  border-bottom: 1px solid #b2b2b2;
}
.closei {
  color: #76c3a2;
  font-size: 0.62rem;
  margin: 0.18rem 0.2rem;
}
.item-normal,
.item-last {
  font-weight: 400;
  color: #b2b2b2;
  font-size: 0.33rem;
  padding-top: 0.3rem;
  padding-bottom: 0.3rem;
  text-align: left;
  position: relative;
  list-style-type: none;
}
.item-first {
  padding-top: 0.86rem;
}
</style>


// WEBPACK FOOTER //
// src/pages/mbPages/Index.vue